import {
    bearerToken
} from './helpers'
import store from '@/store'
import toast from '@/plugins/izitoast'
import VehicleTrackingTransformer from '@/transformers/VehicleTrackingTransformer'

const signalR = require('./../../node_modules/@aspnet/signalr/dist/browser/signalr')

export default class SignalRWebhook {
    constructor () {
        this.baseURL = process.env.VUE_APP_API_SIGNALR_HOST_V2
        this.connection = null
        this.accessToken = bearerToken
    }

    connect () {
        this.connection = new signalR.HubConnectionBuilder()
            .withUrl(this.baseURL, {
                accessTokenFactory: () => {
                    return this.accessToken()
                },
                transport: 1
            })
            .configureLogging(signalR.LogLevel.Information)
            .build()

        this.connection.connection.onclose((error) => {
            console.info('Disconnected', error)
        })

        return this
    }

    async startListen () {
        await this.connection.start()

        let hub = this.connection

        if (!hub['connection'].transport.hasOwnProperty('webSocket')) {
            toast.error('Failed SignalR connection')
            return this
        }

        this.connection = hub

        const connectionUrl = new URL(hub['connection'].transport.webSocket.url)
        const connectionId = connectionUrl.searchParams.get('id')

        store.dispatch('signalR/setSignalRConnectionId', connectionId)

        return this
    }

    disconnect () {
        this.connection.stop()

        return this
    }

    handleLiveTrack () {
        this.connection.on('LiveTrack', (messages) => {
            store.dispatch('trackingModule/updateSubscribedVehiclesPositions', messages)
        })
        return this
    }
}
